<template>
  <div>
    <v-app class="app-tabela">
      <div class="box" style="margin-top: 0px">
        <v-card class="tabela">
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar"
              class="input-bottom"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            @pagination="getPagination"
            :page="currentPage"
            :footer-props="{
              itemsPerPageText: '',
              'items-per-page-options': [10],
              'disable-items-per-page': true,
            }"
            :loading="loading"
            loading-text="Carregando, Por favor espere"
            :headers="headers"
            :items="indexedItems"
            :search="search"
            item-key="id"
            class="elevation-1"
          >
            <template v-slot:item.acoes="{ item }">
              <button class="btn" small text @click="$emit('editar', item)">
                Editar <i class="icofont-pencil"></i>
              </button>
            </template>

            <!-- <template #footer.prepend>
                    <v-spacer />
                  </template> -->
            <!-- <template v-slot:expanded-item="{ headers, item }">
              <td colspan="9">
                <table class="table table-interna">
                  <thead>
                    <tr>
                      <th>INE</th>
                      <th>Equipe</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        {{
                          item.equipe_vinculada != null
                            ? item.equipe_vinculada.nu_ine
                            : ''
                        }}
                      </td>
                      <td>
                        {{
                          item.equipe_vinculada != null
                            ? item.equipe_vinculada.no_equipe
                            : ''
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </template> -->

            <template v-slot:[`footer.page-text`]="items">
              <div class="info-table-item tabela-esus-pec">
                <FonteSincronizadorC />
              </div>
              <span class="paginacao"
                >{{ items.pageStart }} - {{ items.pageStop }} de
                {{ items.itemsLength }} registros</span
              >
            </template>
            <template v-slot:progress>
              <v-progress-linear
                color="blue"
                :height="10"
                indeterminate
              ></v-progress-linear>
            </template>
            <template v-slot:no-data>
              <div class="alert alert-info mb-0">
                <b>Nenhuma informação encontrada.</b>
              </div>
            </template>
            <template v-slot:no-results style="padding: 0px">
              <div class="alert alert-info mb-0">
                <b>Nenhuma informação encontrada.</b>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-app>
  </div>
</template>

<script>
import utils from '@/mixins/utils.js'

export default {
  components: {},
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: '',
    },
  },
  mixins: [utils],
  data() {
    return {
      search: '',
      expanded: [],
      headers: [
        {
          text: 'INEP',
          align: 'start',
          filterable: true,
          value: 'nu_identificador',
        },
        {
          text: 'Nome',
          align: 'start',
          filterable: true,
          value: 'no_estabelecimento',
        },
        {
          text: 'Equipe responsável',
          align: 'start',
          filterable: true,
          value: 'no_equipe',
        },
        { text: 'Ações', value: 'acoes', sortable: false, align: 'end' },
        // { text: '', value: 'data-table-expand' },
      ],
      currentPage: 1,
    }
  },
  computed: {
    indexedItems() {
      return this.cadastros.map((item, index) => {
        return {
          id: index,
          ...item,
        }
      })
    },
  },
  methods: {
    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },
  },
}
</script>

<style></style>
